export const getContentReducer = (state) => state.content;